// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d7f85352","667":"434e33b2"}[chunkId] + ".chunk.js";
};